"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
var initialState = {
    MoneyValue: 0,
    Counter: 0
};
function amountReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case types_1.SET_AMOUNT_VALUE:
            return {
                MoneyValue: action.payload.MoneyValue,
                Counter: action.payload.Counter
            };
        case types_1.RESET_AMOUNT_VALUE:
            return initialState;
        default:
            return state;
    }
}
exports.amountReducer = amountReducer;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/store/amount/reducers.ts
// module id = 2413
// module chunks = 5